// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/services/v1/query_service.proto (package thru.services.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import { file_google_api_client } from "../../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ConsensusStatus, VersionContext } from "../../common/v1/consensus_pb";
import { file_thru_common_v1_consensus } from "../../common/v1/consensus_pb";
import type { Filter } from "../../common/v1/filters_pb";
import { file_thru_common_v1_filters } from "../../common/v1/filters_pb";
import type { PageRequest, PageResponse } from "../../common/v1/pagination_pb";
import { file_thru_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Pubkey, Signature } from "../../common/v1/primitives_pb";
import { file_thru_common_v1_primitives } from "../../common/v1/primitives_pb";
import type { Account, AccountSchema, AccountView, DataSlice, RawAccount, RawAccountSchema } from "../../core/v1/account_pb";
import { file_thru_core_v1_account } from "../../core/v1/account_pb";
import type { Block, BlockSchema, BlockView, RawBlockSchema } from "../../core/v1/block_pb";
import { file_thru_core_v1_block } from "../../core/v1/block_pb";
import type { StateProof, StateProofRequest } from "../../core/v1/state_pb";
import { file_thru_core_v1_state } from "../../core/v1/state_pb";
import type { RawTransactionSchema, Transaction, TransactionExecutionResult, TransactionSchema, TransactionView } from "../../core/v1/transaction_pb";
import { file_thru_core_v1_transaction } from "../../core/v1/transaction_pb";
import type { BlockHash } from "../../core/v1/types_pb";
import { file_thru_core_v1_types } from "../../core/v1/types_pb";
import type { NodeRecord } from "../../core/v1/node_pb";
import { file_thru_core_v1_node } from "../../core/v1/node_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/services/v1/query_service.proto.
 */
export const file_thru_services_v1_query_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_protobuf_timestamp, file_thru_common_v1_consensus, file_thru_common_v1_filters, file_thru_common_v1_pagination, file_thru_common_v1_primitives, file_thru_core_v1_account, file_thru_core_v1_block, file_thru_core_v1_state, file_thru_core_v1_transaction, file_thru_core_v1_types, file_thru_core_v1_node]);

/**
 * GetAccountRequest retrieves a decoded account by public key.
 *
 * @generated from message thru.services.v1.GetAccountRequest
 */
export type GetAccountRequest = Message<"thru.services.v1.GetAccountRequest"> & {
  /**
   * @generated from field: thru.common.v1.Pubkey address = 1;
   */
  address?: Pubkey | undefined;

  /**
   * @generated from field: optional thru.core.v1.AccountView view = 2;
   */
  view?: AccountView | undefined;

  /**
   * @generated from field: thru.common.v1.VersionContext version_context = 3;
   */
  versionContext?: VersionContext | undefined;

  /**
   * @generated from field: optional thru.core.v1.DataSlice data_slice = 5;
   */
  dataSlice?: DataSlice | undefined;
};

/**
 * Describes the message thru.services.v1.GetAccountRequest.
 * Use `create(GetAccountRequestSchema)` to create a new message.
 */
export const GetAccountRequestSchema: GenMessage<GetAccountRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 0);

/**
 * GetRawAccountRequest retrieves raw account bytes by public key.
 *
 * @generated from message thru.services.v1.GetRawAccountRequest
 */
export type GetRawAccountRequest = Message<"thru.services.v1.GetRawAccountRequest"> & {
  /**
   * @generated from field: thru.common.v1.Pubkey address = 1;
   */
  address?: Pubkey | undefined;

  /**
   * Controls which sections of the raw response are returned.
   * ACCOUNT_VIEW_UNSPECIFIED and ACCOUNT_VIEW_FULL (default) return both
   * raw_meta and raw_data. ACCOUNT_VIEW_META_ONLY skips the data fetch
   * entirely and omits raw_data from the response. ACCOUNT_VIEW_DATA_ONLY
   * and ACCOUNT_VIEW_PUBKEY_ONLY are rejected with InvalidArgument: raw_meta
   * is a REQUIRED field on RawAccount, so a raw response without it has no
   * honest encoding, and a raw response of only an address is meaningless.
   *
   * @generated from field: optional thru.core.v1.AccountView view = 2;
   */
  view?: AccountView | undefined;

  /**
   * @generated from field: thru.common.v1.VersionContext version_context = 3;
   */
  versionContext?: VersionContext | undefined;
};

/**
 * Describes the message thru.services.v1.GetRawAccountRequest.
 * Use `create(GetRawAccountRequestSchema)` to create a new message.
 */
export const GetRawAccountRequestSchema: GenMessage<GetRawAccountRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 1);

/**
 * GetTransactionRequest retrieves a decoded transaction by signature.
 *
 * @generated from message thru.services.v1.GetTransactionRequest
 */
export type GetTransactionRequest = Message<"thru.services.v1.GetTransactionRequest"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;

  /**
   * @generated from field: optional thru.core.v1.TransactionView view = 2;
   */
  view?: TransactionView | undefined;

  /**
   * @generated from field: thru.common.v1.VersionContext version_context = 3;
   */
  versionContext?: VersionContext | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 4;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.GetTransactionRequest.
 * Use `create(GetTransactionRequestSchema)` to create a new message.
 */
export const GetTransactionRequestSchema: GenMessage<GetTransactionRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 2);

/**
 * GetRawTransactionRequest retrieves raw transaction bytes by signature.
 *
 * @generated from message thru.services.v1.GetRawTransactionRequest
 */
export type GetRawTransactionRequest = Message<"thru.services.v1.GetRawTransactionRequest"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;

  /**
   * @generated from field: thru.common.v1.VersionContext version_context = 2;
   */
  versionContext?: VersionContext | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 3;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.GetRawTransactionRequest.
 * Use `create(GetRawTransactionRequestSchema)` to create a new message.
 */
export const GetRawTransactionRequestSchema: GenMessage<GetRawTransactionRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 3);

/**
 * GenerateStateProofRequest requests an account state proof.
 *
 * @generated from message thru.services.v1.GenerateStateProofRequest
 */
export type GenerateStateProofRequest = Message<"thru.services.v1.GenerateStateProofRequest"> & {
  /**
   * @generated from field: thru.core.v1.StateProofRequest request = 1;
   */
  request?: StateProofRequest | undefined;
};

/**
 * Describes the message thru.services.v1.GenerateStateProofRequest.
 * Use `create(GenerateStateProofRequestSchema)` to create a new message.
 */
export const GenerateStateProofRequestSchema: GenMessage<GenerateStateProofRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 4);

/**
 * GenerateStateProofResponse contains the generated proof.
 *
 * @generated from message thru.services.v1.GenerateStateProofResponse
 */
export type GenerateStateProofResponse = Message<"thru.services.v1.GenerateStateProofResponse"> & {
  /**
   * @generated from field: thru.core.v1.StateProof proof = 1;
   */
  proof?: StateProof | undefined;
};

/**
 * Describes the message thru.services.v1.GenerateStateProofResponse.
 * Use `create(GenerateStateProofResponseSchema)` to create a new message.
 */
export const GenerateStateProofResponseSchema: GenMessage<GenerateStateProofResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 5);

/**
 * GetBlockRequest retrieves decoded block information by slot or hash.
 *
 * @generated from message thru.services.v1.GetBlockRequest
 */
export type GetBlockRequest = Message<"thru.services.v1.GetBlockRequest"> & {
  /**
   * @generated from oneof thru.services.v1.GetBlockRequest.selector
   */
  selector: {
    /**
     * @generated from field: uint64 slot = 1;
     */
    value: bigint;
    case: "slot";
  } | {
    /**
     * @generated from field: thru.core.v1.BlockHash block_hash = 2;
     */
    value: BlockHash;
    case: "blockHash";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional thru.core.v1.BlockView view = 3;
   */
  view?: BlockView | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 4;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.GetBlockRequest.
 * Use `create(GetBlockRequestSchema)` to create a new message.
 */
export const GetBlockRequestSchema: GenMessage<GetBlockRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 6);

/**
 * GetRawBlockRequest retrieves raw block bytes by slot or hash.
 *
 * @generated from message thru.services.v1.GetRawBlockRequest
 */
export type GetRawBlockRequest = Message<"thru.services.v1.GetRawBlockRequest"> & {
  /**
   * @generated from oneof thru.services.v1.GetRawBlockRequest.selector
   */
  selector: {
    /**
     * @generated from field: uint64 slot = 1;
     */
    value: bigint;
    case: "slot";
  } | {
    /**
     * @generated from field: thru.core.v1.BlockHash block_hash = 2;
     */
    value: BlockHash;
    case: "blockHash";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 3;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.GetRawBlockRequest.
 * Use `create(GetRawBlockRequestSchema)` to create a new message.
 */
export const GetRawBlockRequestSchema: GenMessage<GetRawBlockRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 7);

/**
 * ListAccountsRequest lists accounts using CEL filters.
 *
 * The filter expression supports filtering on account metadata fields using CEL (Common Expression Language).
 * A filter expression is REQUIRED for all ListAccounts requests.
 *
 * Available fields for filtering:
 *   - account.address.value (bytes): The account's public key address
 *   - account.meta.owner.value (bytes): The account owner's public key
 *   - account.meta.balance (uint64): Account balance in native units
 *   - account.meta.seq (uint64): Account sequence number / state counter
 *   - account.meta.nonce (uint64): Account transaction nonce
 *   - account.meta.data_size (uint32): Size of account data in bytes
 *   - account.meta.version (uint32): Account version number
 *   - account.meta.flags (AccountFlags): Account capability flags (message type)
 *   - account.meta.flags.is_program (bool): Flag indicating if account is a program
 *   - account.meta.flags.is_privileged (bool): Flag indicating if account is privileged
 *   - account.meta.flags.is_uncompressable (bool): Flag indicating if account data cannot be compressed
 *   - account.meta.flags.is_ephemeral (bool): Flag indicating if account is ephemeral
 *   - account.meta.flags.is_deleted (bool): Flag indicating if account is deleted
 *   - account.meta.flags.is_new (bool): Flag indicating if account is new
 *   - account.meta.flags.is_compressed (bool): Flag indicating if account data is compressed
 *   - account.meta.last_updated_slot (uint64): Slot when account was last modified
 *
 * Available CEL functions:
 *   - has(field): Check if optional field exists
 *   - uint(value): Convert to uint type
 *   - int(value): Convert to int type
 *   - string(value): Convert to string type
 *   - bytes(value): Convert to bytes type
 *
 * Available filter parameters (accessible via params.* in expressions):
 *   - params.owner_bytes (bytes): Owner public key for owner filtering (REQUIRED when filtering by owner)
 *   - params.prefix (bytes): Byte prefix for range-based filtering
 *   - params.tag (any): Custom tag parameter
 *   - params.min_slot (uint64): Minimum slot parameter
 *   - params.min_updated_slot (uint64): Minimum last_updated_slot for filtering
 *
 * Filter examples:
 *
 * 1. Filter by balance:
 *      filter.expression = "account.meta.balance > uint(1000000)"
 *
 * 2. Filter by balance range:
 *      filter.expression = "account.meta.balance >= uint(100) && account.meta.balance <= uint(10000)"
 *
 * 3. Filter by owner (requires params.owner_bytes):
 *      filter.expression = "account.meta.owner.value == params.owner_bytes"
 *      filter.params["owner_bytes"].bytes_value = <32-byte owner pubkey>
 *
 * 4. Filter by data size:
 *      filter.expression = "account.meta.data_size > uint(0)"
 *      filter.expression = "account.meta.data_size >= uint(100) && account.meta.data_size <= uint(1000)"
 *
 * 5. Filter by nonce:
 *      filter.expression = "account.meta.nonce == uint(0)"
 *
 * 6. Filter by sequence number:
 *      filter.expression = "account.meta.seq >= uint(100)"
 *
 * 7. Filter by version:
 *      filter.expression = "account.meta.version == uint(1)"
 *
 * 8. Filter by specific address (using inline bytes literal with octal escaping):
 *      filter.expression = "account.address.value == b'\001\002\003...'"
 *      Note: Binary bytes must be properly escaped using octal notation (\NNN) for non-printable bytes
 *
 * 9. Filter by address prefix (using range comparison):
 *      filter.expression = "account.address.value >= b'\001\002\003\004' && account.address.value <= b'\001\002\003\004\377\377...'"
 *      Note: Create upper bound by appending 0xff bytes after prefix
 *
 * 10. Combine multiple conditions with AND:
 *      filter.expression = "account.meta.balance > uint(0) && account.meta.data_size == uint(0)"
 *
 * 11. Combine multiple conditions with OR:
 *      filter.expression = "account.meta.balance == uint(0) || account.meta.balance > uint(50000)"
 *
 * 12. Complex combined filters:
 *      filter.expression = "(account.meta.balance > uint(100) && account.meta.balance < uint(10000)) || account.meta.data_size > uint(1000)"
 *
 * 13. Check for optional field existence:
 *      filter.expression = "has(account.address.value)"
 *      filter.expression = "has(account.meta.owner.value)"  // Requires params.owner_bytes
 *
 * 14. Use inequality operators:
 *      filter.expression = "account.meta.balance < uint(5000)"
 *      filter.expression = "account.meta.balance <= uint(5000)"
 *      filter.expression = "account.meta.balance >= uint(100)"
 *      filter.expression = "account.meta.balance != uint(999)"
 *
 * 15. Type conversions:
 *      filter.expression = "account.meta.balance == uint(100)"
 *      filter.expression = "uint(account.meta.data_size) > uint(0)"
 *
 * 16. Filter by account flags (individual flag fields):
 *      filter.expression = "account.meta.flags.is_program == true"
 *      filter.expression = "account.meta.flags.is_privileged == true"
 *      filter.expression = "account.meta.flags.is_uncompressable == true"
 *      filter.expression = "account.meta.flags.is_ephemeral == true"
 *      filter.expression = "account.meta.flags.is_deleted == true"
 *      filter.expression = "account.meta.flags.is_new == true"
 *      filter.expression = "account.meta.flags.is_compressed == true"
 *
 * 17. Combine flag filters with other conditions:
 *      filter.expression = "account.meta.flags.is_program == true && account.meta.balance > uint(0)"
 *
 * 18. Filter by last_updated_slot:
 *      filter.expression = "account.meta.last_updated_slot >= uint(1000)"
 *
 * 19. Filter by last_updated_slot with params:
 *      filter.expression = "account.meta.last_updated_slot >= params.min_updated_slot"
 *      filter.params["min_updated_slot"].uint_value = 1000
 *
 * Limitations:
 *   - The startsWith() function only works with strings, not bytes
 *   - The bytesPrefix() function is NOT available for ListAccounts (use range comparison instead)
 *   - Parameter names other than owner_bytes, prefix, tag, min_slot, min_updated_slot are NOT permitted
 *   - All filters are pushed down to SQL for optimal performance where possible
 *
 * @generated from message thru.services.v1.ListAccountsRequest
 */
export type ListAccountsRequest = Message<"thru.services.v1.ListAccountsRequest"> & {
  /**
   * @generated from field: optional thru.core.v1.AccountView view = 1;
   */
  view?: AccountView | undefined;

  /**
   * @generated from field: optional thru.common.v1.VersionContext version_context = 2;
   */
  versionContext?: VersionContext | undefined;

  /**
   * CEL filter expression (REQUIRED). See message documentation for examples.
   *
   * @generated from field: optional thru.common.v1.Filter filter = 3;
   */
  filter?: Filter | undefined;

  /**
   * @generated from field: optional thru.common.v1.PageRequest page = 4;
   */
  page?: PageRequest | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 5;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.ListAccountsRequest.
 * Use `create(ListAccountsRequestSchema)` to create a new message.
 */
export const ListAccountsRequestSchema: GenMessage<ListAccountsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 8);

/**
 * ListAccountsResponse contains paginated accounts.
 *
 * @generated from message thru.services.v1.ListAccountsResponse
 */
export type ListAccountsResponse = Message<"thru.services.v1.ListAccountsResponse"> & {
  /**
   * @generated from field: repeated thru.core.v1.Account accounts = 1;
   */
  accounts: Account[];

  /**
   * @generated from field: optional thru.common.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message thru.services.v1.ListAccountsResponse.
 * Use `create(ListAccountsResponseSchema)` to create a new message.
 */
export const ListAccountsResponseSchema: GenMessage<ListAccountsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 9);

/**
 * ListBlocksRequest lists blocks with pagination and filtering.
 *
 * Returns blocks ordered from latest slot to earliest (slot DESC) by default.
 * Supports filtering on block header and footer fields using CEL expressions.
 * The whole filter is evaluated by the database. A filter it cannot evaluate, such as a field compared
 * with timestamp(...), arithmetic or the ternary operator, is rejected with INVALID_ARGUMENT
 * (reason "not_translatable").
 *
 * Available fields for filtering:
 *
 * Header fields:
 *   - block.header.slot (uint64): Block slot number
 *   - block.header.version (uint32): Block version number
 *   - block.header.start_slot (uint64): Start slot for block production
 *   - block.header.producer.value (bytes): Block producer's public key
 *   - block.header.expiry_after (uint32): Expiry duration in slots
 *   - block.header.expiry_timestamp (google.protobuf.Timestamp): Expiry timestamp
 *   - block.header.max_block_size (uint32): Maximum block size in bytes
 *   - block.header.max_compute_units (uint64): Maximum compute units allowed
 *   - block.header.max_state_units (uint32): Maximum state units allowed
 *   - block.header.bond_amount_lock_up (uint64): Bond amount lock-up for block production
 *   - block.header.block_hash.value (bytes): Block hash
 *   - block.header.header_signature.value (bytes): Header signature
 *   - block.header.block_time (google.protobuf.Timestamp): Block timestamp
 *
 * Footer fields:
 *   - block.footer.signature.value (bytes): Block signature
 *   - block.footer.status (int32): Block execution status (2 = EXECUTION_STATUS_EXECUTED)
 *   - block.footer.consumed_compute_units (uint64): Total compute units consumed by all transactions
 *   - block.footer.consumed_state_units (uint32): Total state units consumed by all transactions
 *   - block.footer.attestor_payment (uint64): Payment to attestors for block validation
 *
 * Consensus status:
 *   - block.consensus_status (int32): Consensus status (always CONSENSUS_STATUS_INCLUDED for persisted blocks)
 *
 * Available CEL functions:
 *   - has(field): Check if optional field exists
 *   - uint(value): Convert to uint type
 *   - int(value): Convert to int type; int() of a timestamp is whole Unix seconds
 *   - bytes(value): Convert to bytes type
 *   - timestamp(value), duration(value): accepted by CEL but not evaluable by the database; filters
 *     using them are rejected
 *
 * Available filter parameters (accessible via params.* in expressions):
 *   - params.slot (uint64): Slot number for filtering
 *   - params.u64 (uint64): Generic uint64 parameter
 *   - params.producer (bytes): Producer public key for filtering
 *
 * Filter examples:
 *
 * 1. Filter by specific slot:
 *      filter.expression = "block.header.slot == uint(1234)"
 *
 * 2. Filter by slot range:
 *      filter.expression = "block.header.slot >= uint(1000) && block.header.slot <= uint(2000)"
 *
 * 3. Filter by slot using parameter:
 *      filter.expression = "block.header.slot == params.slot"
 *      filter.params["slot"].uint_value = 1234
 *
 * 4. Filter by block version:
 *      filter.expression = "block.header.version == uint(1)"
 *
 * 5. Filter by producer (using parameter):
 *      filter.expression = "block.header.producer.value == params.producer"
 *      filter.params["producer"].bytes_value = <32-byte producer pubkey>
 *
 * 6. Filter by max compute units:
 *      filter.expression = "block.header.max_compute_units > uint(1000000)"
 *      filter.expression = "block.header.max_compute_units >= uint(0) && block.header.max_compute_units <= uint(10000000)"
 *
 * 7. Filter by max state units:
 *      filter.expression = "block.header.max_state_units > uint(0)"
 *
 * 8. Filter by bond amount:
 *      filter.expression = "block.header.bond_amount_lock_up >= uint(0)"
 *      filter.expression = "block.header.bond_amount_lock_up > uint(1000)"
 *
 * 9. Filter by start_slot:
 *      filter.expression = "block.header.start_slot <= uint(5000)"
 *
 * 10. Filter by expiry_after:
 *      filter.expression = "block.header.expiry_after > uint(0)"
 *
 * 11. Filter by max_block_size:
 *      filter.expression = "block.header.max_block_size >= uint(1000000)"
 *
 * 12. Filter by execution status:
 *      filter.expression = "block.footer.status == int(2)"  // EXECUTION_STATUS_EXECUTED
 *
 * 13. Filter by consumed compute units:
 *      filter.expression = "block.footer.consumed_compute_units > uint(0)"
 *      filter.expression = "block.footer.consumed_compute_units >= uint(100) && block.footer.consumed_compute_units <= uint(1000000)"
 *
 * 14. Filter by consumed state units:
 *      filter.expression = "block.footer.consumed_state_units >= uint(0)"
 *      filter.expression = "block.footer.consumed_state_units > uint(10)"
 *
 * 15. Check for footer signature existence:
 *      filter.expression = "has(block.footer.signature)"
 *
 * 16. Check for footer existence:
 *      filter.expression = "has(block.footer)"
 *
 * 17. Check for producer existence:
 *      filter.expression = "has(block.header.producer)"
 *
 * 18. Check for block hash existence:
 *      filter.expression = "has(block.header.block_hash)"
 *
 * 19. Check for header signature existence:
 *      filter.expression = "has(block.header.header_signature)"
 *
 * 20. Check for expiry timestamp existence:
 *      filter.expression = "has(block.header.expiry_timestamp)"
 *
 * 21. Check for block time existence:
 *      filter.expression = "has(block.header.block_time)"
 *
 * 22. Combine multiple header conditions with AND:
 *      filter.expression = "block.header.slot >= uint(1000) && block.header.max_compute_units > uint(1000000)"
 *
 * 23. Combine multiple footer conditions with AND:
 *      filter.expression = "block.footer.consumed_compute_units > uint(0) && block.footer.consumed_state_units > uint(0)"
 *
 * 24. Combine header and footer conditions:
 *      filter.expression = "block.header.slot >= uint(1000) && block.footer.consumed_compute_units > uint(100000)"
 *
 * 25. Combine multiple conditions with OR:
 *      filter.expression = "block.header.slot == uint(100) || block.header.slot == uint(200)"
 *      filter.expression = "block.footer.consumed_compute_units > uint(1000000) || block.footer.consumed_state_units > uint(10000)"
 *
 * 26. Complex combined filters:
 *      filter.expression = "(block.header.slot >= uint(1000) && block.header.slot <= uint(2000)) || block.footer.consumed_compute_units > uint(5000000)"
 *
 * 27. Use inequality operators:
 *      filter.expression = "block.header.max_compute_units < uint(10000000)"
 *      filter.expression = "block.header.max_compute_units <= uint(10000000)"
 *      filter.expression = "block.header.bond_amount_lock_up >= uint(100)"
 *      filter.expression = "block.footer.consumed_compute_units != uint(0)"
 *
 * 28. Combine has() with value checks:
 *      filter.expression = "has(block.header.producer) && block.header.producer.value == params.producer"
 *      filter.params["producer"].bytes_value = <32-byte producer pubkey>
 *
 * 29. Filter by multiple resource limits:
 *      filter.expression = "block.header.max_compute_units > uint(1000000) && block.header.max_state_units > uint(1000) && block.header.max_block_size > uint(1000000)"
 *
 * 30. Filter by block time:
 *      filter.expression = "int(block.header.block_time) >= 1767225600"
 *
 * Note: blocks are stored in slot order. One call reads a bounded number of blocks (about 100,000). When
 * a filter needs more to fill the page, the call returns the matches found so far, possibly none, with a
 * next_page_token to continue from: a short or empty page with a token is not the end of the results.
 * Bound a rare match with block.header.slot to need fewer calls.
 *
 * @generated from message thru.services.v1.ListBlocksRequest
 */
export type ListBlocksRequest = Message<"thru.services.v1.ListBlocksRequest"> & {
  /**
   * CEL filter expression (OPTIONAL). See message documentation for examples.
   *
   * @generated from field: optional thru.common.v1.Filter filter = 1;
   */
  filter?: Filter | undefined;

  /**
   * @generated from field: optional thru.common.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;

  /**
   * @generated from field: optional thru.core.v1.BlockView view = 3;
   */
  view?: BlockView | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 4;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.ListBlocksRequest.
 * Use `create(ListBlocksRequestSchema)` to create a new message.
 */
export const ListBlocksRequestSchema: GenMessage<ListBlocksRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 10);

/**
 * ListBlocksResponse returns a page of blocks.
 *
 * @generated from message thru.services.v1.ListBlocksResponse
 */
export type ListBlocksResponse = Message<"thru.services.v1.ListBlocksResponse"> & {
  /**
   * @generated from field: repeated thru.core.v1.Block blocks = 1;
   */
  blocks: Block[];

  /**
   * @generated from field: optional thru.common.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message thru.services.v1.ListBlocksResponse.
 * Use `create(ListBlocksResponseSchema)` to create a new message.
 */
export const ListBlocksResponseSchema: GenMessage<ListBlocksResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 11);

/**
 * ListTransactionsForAccountRequest lists transactions involving a specific account.
 *
 * This RPC returns all transactions where the specified account appears in any
 * capacity (fee payer, signer, or affected account). Results can be filtered
 * using CEL expressions on transaction properties.
 *
 * ## Available Filter Fields
 *
 * - `transaction.slot` (uint64): Block slot number
 * - `transaction.block_offset` (uint32): Position within block
 * - `transaction.signature.value` (bytes): Transaction signature
 *
 * Header fields (a transaction whose header is not stored reads them as zero or empty):
 * - `transaction.header.version` (uint32): Transaction format version
 * - `transaction.header.fee` (uint64): Transaction fee
 * - `transaction.header.nonce` (uint64): Sender account nonce
 * - `transaction.header.start_slot` (uint64): Earliest slot for execution
 * - `transaction.header.expiry_after` (uint32): Expiry duration in slots
 * - `transaction.header.requested_compute_units` (uint64): Requested compute units
 * - `transaction.header.requested_memory_units` (uint32): Requested memory units
 * - `transaction.header.requested_state_units` (uint32): Requested state units
 * - `transaction.header.fee_payer_pubkey.value` (bytes): Fee payer public key
 * - `transaction.header.program_pubkey.value` (bytes): Program public key
 * - `transaction.header.fee_payer_signature.value` (bytes): Fee payer signature
 *
 * Execution result fields:
 * - `transaction.execution_result.vm_error` (TransactionVmError enum): VM execution status (0 = success)
 * - `transaction.execution_result.user_error_code` (uint64): User-defined error code
 * - `transaction.execution_result.execution_result` (uint64): Alias for user_error_code
 * - `transaction.execution_result.consumed_compute_units` (uint64): Compute units used
 * - `transaction.execution_result.consumed_memory_units` (uint32): Memory units used
 * - `transaction.execution_result.consumed_state_units` (uint32): State units used
 * - `transaction.execution_result.events_count` (uint32): Number of events emitted
 * - `transaction.execution_result.events_size` (uint32): Total size of event data in bytes
 *
 * ## Filter Examples
 *
 * ### Filter by slot
 * ```
 * filter {
 *   expression: "transaction.slot == params.slot"
 *   params {
 *     key: "slot"
 *     value { int_value: 12345 }
 *   }
 * }
 * ```
 *
 * ### Filter by block offset
 * ```
 * filter {
 *   expression: "transaction.block_offset == uint(5)"
 * }
 * ```
 *
 * ### Filter by compute units (high usage)
 * ```
 * filter {
 *   expression: "transaction.execution_result.consumed_compute_units >= uint(1000000)"
 * }
 * ```
 *
 * ### Filter by memory units
 * ```
 * filter {
 *   expression: "transaction.execution_result.consumed_memory_units > uint(0)"
 * }
 * ```
 *
 * ### Filter by state units
 * ```
 * filter {
 *   expression: "transaction.execution_result.consumed_state_units > uint(0)"
 * }
 * ```
 *
 * ### Filter successful transactions (by error code)
 * ```
 * filter {
 *   expression: "transaction.execution_result.user_error_code == uint(0)"
 * }
 * ```
 *
 * ### Filter by VM execution status
 * ```
 * filter {
 *   expression: "transaction.execution_result.vm_error == int(0)"
 * }
 * ```
 *
 * ### Filter transactions with events
 * ```
 * filter {
 *   expression: "transaction.execution_result.events_count > uint(0)"
 * }
 * ```
 *
 * ### Filter by event data size
 * ```
 * filter {
 *   expression: "transaction.execution_result.events_size > uint(0)"
 * }
 * ```
 *
 * ### Check for optional fields using has()
 * ```
 * filter {
 *   expression: "has(transaction.execution_result)"
 * }
 * ```
 *
 * ### Combined filters with AND/OR
 * ```
 * filter {
 *   expression: "transaction.execution_result.consumed_compute_units >= uint(1000000) && transaction.execution_result.user_error_code == uint(0)"
 * }
 * ```
 *
 * ### Using params for dynamic values
 * ```
 * filter {
 *   expression: "transaction.execution_result.consumed_compute_units >= params.u64"
 *   params {
 *     key: "u64"
 *     value { int_value: 500000 }
 *   }
 * }
 * ```
 *
 * ## Available Functions
 *
 * - `has(field)`: Check if optional field is present
 * - `uint(value)`: Convert to unsigned integer
 * - `int(value)`: Convert to signed integer
 * - `string(value)`: Convert to string type
 * - `bytes(value)`: Convert to bytes type
 *
 * ## Available Filter Parameters
 *
 * - `params.slot` (uint64): Slot number for filtering
 * - `params.u64` (uint64): Generic uint64 parameter
 * - `params.pubkey` (Pubkey): Public key parameter for filtering
 *
 * The whole filter is evaluated by the database. A filter it cannot evaluate,
 * such as arithmetic, the ternary operator or `string()` of a field, is
 * rejected with INVALID_ARGUMENT (reason "not_translatable").
 *
 * ## Performance Notes
 *
 * One call reads a bounded number of the account's transactions (about
 * 4,096). When a filter needs more to fill the page, the call returns the
 * matches found so far, possibly none, with a next_page_token to continue
 * from: a short or empty page with a token is not the end of the results.
 *
 * @generated from message thru.services.v1.ListTransactionsForAccountRequest
 */
export type ListTransactionsForAccountRequest = Message<"thru.services.v1.ListTransactionsForAccountRequest"> & {
  /**
   * @generated from field: thru.common.v1.Pubkey account = 1;
   */
  account?: Pubkey | undefined;

  /**
   * @generated from field: optional thru.common.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;

  /**
   * Optional CEL filter applied after the account constraint.
   *
   * @generated from field: optional thru.common.v1.Filter filter = 3;
   */
  filter?: Filter | undefined;
};

/**
 * Describes the message thru.services.v1.ListTransactionsForAccountRequest.
 * Use `create(ListTransactionsForAccountRequestSchema)` to create a new message.
 */
export const ListTransactionsForAccountRequestSchema: GenMessage<ListTransactionsForAccountRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 12);

/**
 * ListTransactionsForAccountResponse contains transaction data.
 *
 *
 * @generated from message thru.services.v1.ListTransactionsForAccountResponse
 */
export type ListTransactionsForAccountResponse = Message<"thru.services.v1.ListTransactionsForAccountResponse"> & {
  /**
   * @generated from field: optional thru.common.v1.PageResponse page = 1;
   */
  page?: PageResponse | undefined;

  /**
   * @generated from field: repeated thru.core.v1.Transaction transactions = 2;
   */
  transactions: Transaction[];
};

/**
 * Describes the message thru.services.v1.ListTransactionsForAccountResponse.
 * Use `create(ListTransactionsForAccountResponseSchema)` to create a new message.
 */
export const ListTransactionsForAccountResponseSchema: GenMessage<ListTransactionsForAccountResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 13);

/**
 * GetVersionRequest fetches component version strings.
 *
 * @generated from message thru.services.v1.GetVersionRequest
 */
export type GetVersionRequest = Message<"thru.services.v1.GetVersionRequest"> & {
};

/**
 * Describes the message thru.services.v1.GetVersionRequest.
 * Use `create(GetVersionRequestSchema)` to create a new message.
 */
export const GetVersionRequestSchema: GenMessage<GetVersionRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 14);

/**
 * GetVersionResponse returns version information per component.
 *
 * @generated from message thru.services.v1.GetVersionResponse
 */
export type GetVersionResponse = Message<"thru.services.v1.GetVersionResponse"> & {
  /**
   * @generated from field: map<string, string> versions = 1;
   */
  versions: { [key: string]: string };
};

/**
 * Describes the message thru.services.v1.GetVersionResponse.
 * Use `create(GetVersionResponseSchema)` to create a new message.
 */
export const GetVersionResponseSchema: GenMessage<GetVersionResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 15);

/**
 * GetEventRequest fetches an event by identifier.
 *
 * @generated from message thru.services.v1.GetEventRequest
 */
export type GetEventRequest = Message<"thru.services.v1.GetEventRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: optional thru.common.v1.VersionContext version_context = 2;
   */
  versionContext?: VersionContext | undefined;
};

/**
 * Describes the message thru.services.v1.GetEventRequest.
 * Use `create(GetEventRequestSchema)` to create a new message.
 */
export const GetEventRequestSchema: GenMessage<GetEventRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 16);

/**
 * Event represents a transaction event emitted by the chain.
 *
 * @generated from message thru.services.v1.Event
 */
export type Event = Message<"thru.services.v1.Event"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: thru.common.v1.Signature transaction_signature = 2;
   */
  transactionSignature?: Signature | undefined;

  /**
   * @generated from field: optional thru.common.v1.Pubkey program = 3;
   */
  program?: Pubkey | undefined;

  /**
   * @generated from field: optional bytes payload = 4;
   */
  payload?: Uint8Array | undefined;

  /**
   * @generated from field: optional uint64 slot = 5;
   */
  slot?: bigint | undefined;

  /**
   * @generated from field: optional uint32 call_idx = 6;
   */
  callIdx?: number | undefined;

  /**
   * @generated from field: optional uint32 program_idx = 7;
   */
  programIdx?: number | undefined;

  /**
   * @generated from field: optional uint32 payload_size = 8;
   */
  payloadSize?: number | undefined;

  /**
   * @generated from field: optional uint32 block_offset = 9;
   */
  blockOffset?: number | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp timestamp = 10;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from field: optional thru.common.v1.Pubkey fee_payer = 11;
   */
  feePayer?: Pubkey | undefined;
};

/**
 * Describes the message thru.services.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 17);

/**
 * ListEventsRequest lists events with CEL filtering and pagination.
 *
 * Returns events ordered from most recent to older (slot DESC, block_offset DESC, call_idx DESC).
 * Supports filtering on event metadata and payload using CEL expressions with specialized byte functions.
 * The whole filter is evaluated by the database. A filter it cannot evaluate, such as event_id.startsWith,
 * event.timestamp compared with timestamp(...), arithmetic or the ternary operator, is rejected with
 * INVALID_ARGUMENT (reason "not_translatable").
 *
 * Available fields for filtering:
 *   - event.event_id (string): Event identifier "{signature}:{slot}:{block_offset}:{call_idx}:{event_idx}";
 *     == and != only. A value that is not an identifier ListEvents returns matches nothing.
 *   - event.transaction_signature.value (bytes): Transaction signature that emitted the event
 *   - event.slot (uint64): Block slot number where event was emitted
 *   - event.call_idx (uint32): Instruction call index within transaction
 *   - event.block_offset (uint32): Transaction's position within the block
 *   - event.timestamp (google.protobuf.Timestamp): Block time; has() and int(event.timestamp) (Unix seconds) only
 *   - event.program (Pubkey): has() only; compare event.program.value
 *   - event.program.value (bytes): Program public key that emitted the event; empty when unset
 *   - event.program_idx (uint32): Program index within transaction
 *   - event.payload (bytes): Event payload data
 *   - event.payload_size (uint32): Size of event payload in bytes
 *   - event.fee_payer (Pubkey): has() only; compare event.fee_payer.value
 *   - event.fee_payer.value (bytes): Fee payer's public key for the transaction; empty when unset
 *
 * Available CEL functions:
 *   - has(field): Check if optional field exists
 *   - first1Byte(bytes): Extract first byte as uint8
 *   - first4Bytes(bytes): Extract first 4 bytes as uint32 (little-endian)
 *   - first8Bytes(bytes): Extract first 8 bytes as uint64 (little-endian)
 *   - bytesPrefix(bytes, prefix): Check if bytes start with prefix
 *   - uint(value): Convert to uint type
 *   - int(value): Convert to int type
 *   - string(value): Convert to string type
 *   - bytes(value): Convert to bytes type
 *   - double(value): Convert to double type
 *   - timestamp(value), duration(value), startsWith(string, prefix): accepted by CEL but not evaluable by
 *     the database; filters using them on event fields are rejected
 *
 * Available filter parameters (accessible via params.* in expressions):
 *   - params.slot (uint64): Slot number for filtering
 *   - params.u64 (uint64): Generic uint64 parameter for payload matching
 *   - params.signature (Signature): Transaction signature for filtering
 *   - params.signature.value (bytes): Transaction signature bytes for filtering
 *   - params.address (Pubkey): Program address for filtering
 *   - params.address.value (bytes): Program address bytes for filtering
 *   - params.prefix (bytes): Byte prefix for payload filtering
 *   - params.timestamp (int64): Unix seconds, compared with int(event.timestamp)
 *
 * Filter examples:
 *
 * 1. Filter by slot:
 *      filter.expression = "event.slot > uint(1000)"
 *      filter.expression = "event.slot >= uint(100) && event.slot <= uint(200)"
 *
 * 2. Filter by slot using parameter:
 *      filter.expression = "event.slot >= params.slot"
 *      filter.params["slot"].int_value = 1234
 *
 * 3. Filter by call index:
 *      filter.expression = "event.call_idx == uint(0)"  // First instruction
 *      filter.expression = "event.call_idx > uint(0)"   // Nested instructions
 *
 * 4. Filter by block offset:
 *      filter.expression = "event.block_offset >= uint(0)"
 *      filter.expression = "event.block_offset == uint(5)"
 *
 * 5. Filter by transaction signature (using parameter):
 *      filter.expression = "event.transaction_signature.value == params.signature"
 *      filter.params["signature"].signature_value.value = <64-byte signature>
 *
 * 6. Filter by program address (using parameter):
 *      filter.expression = "has(event.program) && event.program.value == params.address"
 *      filter.params["address"].pubkey_value.value = <32-byte program pubkey>
 *
 * 7. Filter by event ID:
 *      filter.expression = "event.event_id == \"{signature}:{slot}:{block_offset}:{call_idx}:{event_idx}\""
 *
 * 8. Check for payload existence:
 *      filter.expression = "has(event.payload)"
 *
 * 9. Check for program existence:
 *      filter.expression = "has(event.program)"
 *
 * 10. Filter by payload first byte (event type):
 *      filter.expression = "has(event.payload) && first1Byte(event.payload) == uint(1)"  // MESSAGE events
 *      filter.expression = "has(event.payload) && first1Byte(event.payload) == uint(2)"  // Other type
 *
 * 11. Filter by payload first 4 bytes (uint32 event type):
 *      filter.expression = "has(event.payload) && first4Bytes(event.payload) == uint(2)"  // COUNTER events
 *      filter.expression = "has(event.payload) && first4Bytes(event.payload) == params.u64"
 *      filter.params["u64"].int_value = 2
 *
 * 12. Filter by payload first 8 bytes (uint64 event type):
 *      filter.expression = "has(event.payload) && first8Bytes(event.payload) == uint(6)"  // PATTERN events
 *      filter.expression = "has(event.payload) && first8Bytes(event.payload) == params.u64"
 *      filter.params["u64"].int_value = 6
 *
 * 13. Filter by payload byte prefix:
 *      filter.expression = "bytesPrefix(event.payload, params.prefix)"
 *      filter.params["prefix"].bytes_value = <byte prefix to match>
 *
 * 14. Combine slot and call_idx filters:
 *      filter.expression = "event.slot > uint(1000) && event.call_idx == uint(0)"
 *
 * 15. Combine slot, call_idx, and payload existence:
 *      filter.expression = "event.slot > uint(1000) && event.call_idx == uint(0) && has(event.payload)"
 *
 * 16. Filter by program and payload type:
 *      filter.expression = "has(event.program) && event.program.value == params.address && first1Byte(event.payload) == uint(1)"
 *      filter.params["address"].pubkey_value.value = <32-byte program pubkey>
 *
 * 17. Filter MESSAGE events (type 1) with specific program:
 *      filter.expression = "has(event.payload) && first1Byte(event.payload) == uint(1) && event.program.value == params.address"
 *      filter.params["address"].pubkey_value.value = <32-byte program pubkey>
 *
 * 18. Filter COUNTER events (type 2) in slot range:
 *      filter.expression = "has(event.payload) && first4Bytes(event.payload) == uint(2) && event.slot >= uint(100) && event.slot <= uint(200)"
 *
 * 19. Filter PATTERN events (type 6) with payload prefix:
 *      filter.expression = "has(event.payload) && first8Bytes(event.payload) == uint(6) && bytesPrefix(event.payload, params.prefix)"
 *      filter.params["prefix"].bytes_value = <pattern prefix bytes>
 *
 * 20. Complex combined filter:
 *      filter.expression = "(event.slot > uint(1000) && event.call_idx == uint(0)) || first1Byte(event.payload) == uint(1)"
 *
 * 21. Filter events from specific transaction:
 *      filter.expression = "event.transaction_signature.value == params.signature && has(event.payload)"
 *      filter.params["signature"].signature_value.value = <64-byte signature>
 *
 * 22. Filter by multiple payload type options:
 *      filter.expression = "has(event.payload) && (first1Byte(event.payload) == uint(1) || first1Byte(event.payload) == uint(2))"
 *
 * 23. Filter nested instruction events:
 *      filter.expression = "event.call_idx > uint(0) && has(event.program)"
 *
 * 24. Filter first instruction events only:
 *      filter.expression = "event.call_idx == uint(0)"
 *
 * 25. Filter events with payload longer than specific size (using bytesPrefix with empty prefix):
 *      filter.expression = "has(event.payload)"
 *
 * 26. Combine has() checks:
 *      filter.expression = "has(event.program) && has(event.payload) && has(event.timestamp)"
 *
 * 27. Use inequality operators:
 *      filter.expression = "event.slot < uint(10000)"
 *      filter.expression = "event.slot <= uint(10000)"
 *      filter.expression = "event.call_idx >= uint(0)"
 *      filter.expression = "event.block_offset != uint(0)"
 *
 * 28. Filter by timestamp (if available):
 *      filter.expression = "has(event.timestamp)"
 *
 * 29. Filter by block time:
 *      filter.expression = "int(event.timestamp) >= params.timestamp"
 *      filter.params["timestamp"].int_value = 1767225600
 *
 * 30. Complex payload and metadata filter:
 *      filter.expression = "event.slot >= params.slot && has(event.payload) && first8Bytes(event.payload) == params.u64 && event.program.value == params.address"
 *      filter.params["slot"].int_value = 1000
 *      filter.params["u64"].int_value = 6
 *      filter.params["address"].pubkey_value.value = <32-byte program pubkey>
 *
 * Note: Only slot, block_offset and call_idx are in the table's sort key, and event_id equality selects by
 * them too. One call reads a bounded number of rows (about 100,000). When a filter needs more to fill the
 * page, the call returns the matches found so far, possibly none, with a next_page_token to continue from:
 * a short or empty page with a token is not the end of the results. Bound a rare match with event.slot to
 * need fewer calls.
 *
 * @generated from message thru.services.v1.ListEventsRequest
 */
export type ListEventsRequest = Message<"thru.services.v1.ListEventsRequest"> & {
  /**
   * CEL filter expression (OPTIONAL). See message documentation for examples.
   *
   * @generated from field: optional thru.common.v1.Filter filter = 1;
   */
  filter?: Filter | undefined;

  /**
   * @generated from field: optional thru.common.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;

  /**
   * @generated from field: optional thru.common.v1.VersionContext version_context = 3;
   */
  versionContext?: VersionContext | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 4;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema: GenMessage<ListEventsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 18);

/**
 * ListEventsResponse returns paginated events.
 *
 * @generated from message thru.services.v1.ListEventsResponse
 */
export type ListEventsResponse = Message<"thru.services.v1.ListEventsResponse"> & {
  /**
   * @generated from field: repeated thru.services.v1.Event events = 1;
   */
  events: Event[];

  /**
   * @generated from field: optional thru.common.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message thru.services.v1.ListEventsResponse.
 * Use `create(ListEventsResponseSchema)` to create a new message.
 */
export const ListEventsResponseSchema: GenMessage<ListEventsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 19);

/**
 * ListTransactionsRequest lists executed transactions with CEL filtering and pagination.
 *
 * Returns transactions ordered from most recent to older (slot DESC, block_offset DESC).
 * Supports filtering on transaction metadata and execution results using CEL expressions.
 * The whole filter is evaluated by the database. A filter it cannot evaluate, such as arithmetic, the
 * ternary operator or string() of a field, is rejected with INVALID_ARGUMENT (reason "not_translatable").
 *
 * Available fields for filtering:
 *   - transaction.slot (uint64): Block slot number where transaction was executed
 *   - transaction.block_offset (uint32): Transaction's position within the block
 *   - transaction.signature.value (bytes): Transaction signature
 *
 * Header fields (a transaction whose header is not stored reads them as zero or empty):
 *   - transaction.header.version (uint32): Transaction format version
 *   - transaction.header.fee (uint64): Transaction fee
 *   - transaction.header.nonce (uint64): Sender account nonce
 *   - transaction.header.start_slot (uint64): Earliest slot for execution
 *   - transaction.header.expiry_after (uint32): Expiry duration in slots
 *   - transaction.header.requested_compute_units (uint64): Requested compute units
 *   - transaction.header.requested_memory_units (uint32): Requested memory units
 *   - transaction.header.requested_state_units (uint32): Requested state units
 *   - transaction.header.fee_payer_pubkey.value (bytes): Fee payer public key
 *   - transaction.header.program_pubkey.value (bytes): Program public key
 *   - transaction.header.fee_payer_signature.value (bytes): Fee payer signature
 *
 * Execution result fields:
 *   - transaction.execution_result.vm_error (TransactionVmError enum): VM error code (0 = success)
 *   - transaction.execution_result.user_error_code (uint64): User-defined error code
 *   - transaction.execution_result.execution_result (uint64): Alias for user_error_code
 *   - transaction.execution_result.consumed_compute_units (uint64): Compute units consumed
 *   - transaction.execution_result.consumed_memory_units (uint32): Memory units consumed
 *   - transaction.execution_result.consumed_state_units (uint32): State units consumed
 *   - transaction.execution_result.events_count (uint32): Number of events emitted
 *   - transaction.execution_result.events_size (uint32): Total size of events in bytes
 *
 * Available CEL functions:
 *   - has(field): Check if optional field exists
 *   - uint(value): Convert to uint type
 *   - int(value): Convert to int type
 *   - string(value): Convert to string type
 *   - bytes(value): Convert to bytes type
 *
 * Available filter parameters (accessible via params.* in expressions):
 *   - params.slot (uint64): Slot number for filtering
 *   - params.u64 (uint64): Generic uint64 parameter
 *   - params.pubkey (Pubkey): Public key parameter for filtering
 *
 * Filter examples:
 *
 * 1. Filter by slot range:
 *      filter.expression = "transaction.slot >= uint(1000) && transaction.slot <= uint(2000)"
 *
 * 2. Filter by successful transactions (no error):
 *      filter.expression = "transaction.execution_result.user_error_code == uint(0)"
 *      filter.expression = "transaction.execution_result.vm_error == int(0)"
 *
 * 3. Filter by specific VM error:
 *      filter.expression = "transaction.execution_result.vm_error == int(2)"  // VM_REVERT
 *      filter.expression = "transaction.execution_result.vm_error == int(4)"  // NONCE_TOO_LOW
 *      filter.expression = "transaction.execution_result.vm_error == int(5)"  // NONCE_TOO_HIGH
 *
 * 4. Filter by resource usage:
 *      filter.expression = "transaction.execution_result.consumed_compute_units > uint(1000)"
 *      filter.expression = "transaction.execution_result.consumed_memory_units > uint(0)"
 *      filter.expression = "transaction.execution_result.consumed_state_units >= uint(0)"
 *
 * 5. Filter by compute units range:
 *      filter.expression = "transaction.execution_result.consumed_compute_units >= uint(0) && transaction.execution_result.consumed_compute_units < uint(1000000)"
 *
 * 6. Filter by events count:
 *      filter.expression = "transaction.execution_result.events_count == uint(0)"  // No events (transfers)
 *      filter.expression = "transaction.execution_result.events_count > uint(0)"   // Has events
 *      filter.expression = "transaction.execution_result.events_count == uint(1)"  // Exactly 1 event
 *
 * 7. Filter by events size:
 *      filter.expression = "transaction.execution_result.events_size == uint(0)"  // No events
 *      filter.expression = "transaction.execution_result.events_size > uint(0)"   // Has events
 *      filter.expression = "transaction.execution_result.events_size >= uint(100)" // Large events
 *      filter.expression = "transaction.execution_result.events_size >= uint(50) && transaction.execution_result.events_size <= uint(200)"
 *
 * 8. Filter by block offset:
 *      filter.expression = "transaction.block_offset >= uint(0)"
 *      filter.expression = "transaction.block_offset == uint(5)"
 *
 * 9. Combine multiple conditions with AND:
 *      filter.expression = "transaction.execution_result.user_error_code == uint(0) && transaction.execution_result.consumed_compute_units > uint(0)"
 *
 * 10. Combine multiple conditions with OR:
 *      filter.expression = "transaction.execution_result.user_error_code == uint(0) || transaction.execution_result.user_error_code != uint(0)"
 *      filter.expression = "transaction.execution_result.vm_error == int(2) || transaction.execution_result.vm_error == int(4)"
 *
 * 11. Complex combined filters:
 *      filter.expression = "(transaction.slot >= uint(0) && transaction.execution_result.user_error_code == uint(0)) || transaction.execution_result.consumed_compute_units > uint(100000)"
 *
 * 12. Check for field existence:
 *      filter.expression = "has(transaction.execution_result)"
 *
 * 13. Use inequality operators:
 *      filter.expression = "transaction.execution_result.consumed_compute_units < uint(1000000)"
 *      filter.expression = "transaction.execution_result.consumed_compute_units <= uint(1000000)"
 *      filter.expression = "transaction.execution_result.consumed_compute_units >= uint(0)"
 *      filter.expression = "transaction.execution_result.user_error_code != uint(999)"
 *
 * 14. Use params.slot parameter:
 *      filter.expression = "transaction.slot == params.slot"
 *      filter.params["slot"].uint_value = 1234
 *
 * 15. Use params.u64 with type conversion:
 *      filter.expression = "transaction.execution_result.consumed_compute_units < uint(params.u64)"
 *      filter.params["u64"].uint_value = 1000000
 *
 * The return_events flag controls whether event data is included in the response:
 *   - return_events = false (default): Only event counts/sizes are returned, not actual event data
 *   - return_events = true: Full event data is included in execution results
 *
 * Note: transactions are stored by signature, not in slot order. A call whose filter would read more than
 * about 100,000 rows reads one 100,000-slot range instead. When a filter needs more to fill the page, the
 * call returns the matches found so far, possibly none, with a next_page_token to continue from: a short or
 * empty page with a token is not the end of the results. Bound a rare match with transaction.slot to need
 * fewer calls.
 *
 * @generated from message thru.services.v1.ListTransactionsRequest
 */
export type ListTransactionsRequest = Message<"thru.services.v1.ListTransactionsRequest"> & {
  /**
   * CEL filter expression (OPTIONAL). See message documentation for examples.
   *
   * @generated from field: optional thru.common.v1.Filter filter = 1;
   */
  filter?: Filter | undefined;

  /**
   * @generated from field: optional thru.common.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;

  /**
   * Whether to include event data in results (default: false)
   *
   * @generated from field: optional bool return_events = 3;
   */
  returnEvents?: boolean | undefined;

  /**
   * @generated from field: optional thru.common.v1.VersionContext version_context = 4;
   */
  versionContext?: VersionContext | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 5;
   */
  minConsensus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.services.v1.ListTransactionsRequest.
 * Use `create(ListTransactionsRequestSchema)` to create a new message.
 */
export const ListTransactionsRequestSchema: GenMessage<ListTransactionsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 20);

/**
 * ListTransactionsResponse returns paginated executed transactions.
 *
 * @generated from message thru.services.v1.ListTransactionsResponse
 */
export type ListTransactionsResponse = Message<"thru.services.v1.ListTransactionsResponse"> & {
  /**
   * @generated from field: repeated thru.core.v1.Transaction transactions = 1;
   */
  transactions: Transaction[];

  /**
   * @generated from field: optional thru.common.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message thru.services.v1.ListTransactionsResponse.
 * Use `create(ListTransactionsResponseSchema)` to create a new message.
 */
export const ListTransactionsResponseSchema: GenMessage<ListTransactionsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 21);

/**
 * GetTransactionStatusRequest fetches execution status for a transaction.
 *
 * @generated from message thru.services.v1.GetTransactionStatusRequest
 */
export type GetTransactionStatusRequest = Message<"thru.services.v1.GetTransactionStatusRequest"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;
};

/**
 * Describes the message thru.services.v1.GetTransactionStatusRequest.
 * Use `create(GetTransactionStatusRequestSchema)` to create a new message.
 */
export const GetTransactionStatusRequestSchema: GenMessage<GetTransactionStatusRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 22);

/**
 * TransactionStatus captures status metadata for a transaction.
 *
 * @generated from message thru.services.v1.TransactionStatus
 */
export type TransactionStatus = Message<"thru.services.v1.TransactionStatus"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus consensus_status = 2;
   */
  consensusStatus?: ConsensusStatus | undefined;

  /**
   * @generated from field: optional thru.core.v1.TransactionExecutionResult execution_result = 3;
   */
  executionResult?: TransactionExecutionResult | undefined;
};

/**
 * Describes the message thru.services.v1.TransactionStatus.
 * Use `create(TransactionStatusSchema)` to create a new message.
 */
export const TransactionStatusSchema: GenMessage<TransactionStatus> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 23);

/**
 * @generated from message thru.services.v1.GetHeightRequest
 */
export type GetHeightRequest = Message<"thru.services.v1.GetHeightRequest"> & {
};

/**
 * Describes the message thru.services.v1.GetHeightRequest.
 * Use `create(GetHeightRequestSchema)` to create a new message.
 */
export const GetHeightRequestSchema: GenMessage<GetHeightRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 24);

/**
 * GetHeightResponse
 *
 * @generated from message thru.services.v1.GetHeightResponse
 */
export type GetHeightResponse = Message<"thru.services.v1.GetHeightResponse"> & {
  /**
   * @generated from field: uint64 finalized = 1;
   */
  finalized: bigint;

  /**
   * @generated from field: uint64 locally_executed = 2;
   */
  locallyExecuted: bigint;

  /**
   * @generated from field: uint64 cluster_executed = 3;
   */
  clusterExecuted: bigint;
};

/**
 * Describes the message thru.services.v1.GetHeightResponse.
 * Use `create(GetHeightResponseSchema)` to create a new message.
 */
export const GetHeightResponseSchema: GenMessage<GetHeightResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 25);

/**
 * GetChainInfoRequest retrieves chain-level information.
 *
 * @generated from message thru.services.v1.GetChainInfoRequest
 */
export type GetChainInfoRequest = Message<"thru.services.v1.GetChainInfoRequest"> & {
};

/**
 * Describes the message thru.services.v1.GetChainInfoRequest.
 * Use `create(GetChainInfoRequestSchema)` to create a new message.
 */
export const GetChainInfoRequestSchema: GenMessage<GetChainInfoRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 26);

/**
 * GetChainInfoResponse returns chain-level information.
 *
 * @generated from message thru.services.v1.GetChainInfoResponse
 */
export type GetChainInfoResponse = Message<"thru.services.v1.GetChainInfoResponse"> & {
  /**
   * Chain identifier, unique per network (similar to Ethereum chain ID).
   * Used to prevent transaction replay across different chains.
   *
   * @generated from field: uint32 chain_id = 1;
   */
  chainId: number;

  /**
   * Minimum timestamp (nanoseconds since epoch) at which 4f+1 validator weight
   * has reported advancement. Zero if not yet available.
   *
   * @generated from field: uint64 min_lock_time = 2;
   */
  minLockTime: bigint;
};

/**
 * Describes the message thru.services.v1.GetChainInfoResponse.
 * Use `create(GetChainInfoResponseSchema)` to create a new message.
 */
export const GetChainInfoResponseSchema: GenMessage<GetChainInfoResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 27);

/**
 * GetStateRootsRequest retrieves up to 257 state roots ending at a specified slot.
 * Used for transaction replay to verify state proofs against historical roots.
 * Returns state roots in ascending slot order, from (slot - 256) to slot (inclusive).
 *
 * @generated from message thru.services.v1.GetStateRootsRequest
 */
export type GetStateRootsRequest = Message<"thru.services.v1.GetStateRootsRequest"> & {
  /**
   * The slot to retrieve state roots up to (inclusive).
   * Returns up to 257 state roots ending at this slot.
   * If not specified, returns state roots ending at the latest slot at or
   * below the durable cursor. A slot above the durable cursor is rejected
   * with FAILED_PRECONDITION; if no slot is durable yet the call returns
   * UNAVAILABLE.
   *
   * @generated from field: optional uint64 slot = 1;
   */
  slot?: bigint | undefined;
};

/**
 * Describes the message thru.services.v1.GetStateRootsRequest.
 * Use `create(GetStateRootsRequestSchema)` to create a new message.
 */
export const GetStateRootsRequestSchema: GenMessage<GetStateRootsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 28);

/**
 * StateRootEntry represents a state root for a specific slot.
 *
 * @generated from message thru.services.v1.StateRootEntry
 */
export type StateRootEntry = Message<"thru.services.v1.StateRootEntry"> & {
  /**
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * @generated from field: bytes state_root = 2;
   */
  stateRoot: Uint8Array;
};

/**
 * Describes the message thru.services.v1.StateRootEntry.
 * Use `create(StateRootEntrySchema)` to create a new message.
 */
export const StateRootEntrySchema: GenMessage<StateRootEntry> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 29);

/**
 * GetStateRootsResponse contains up to 257 state roots ending at the requested slot.
 *
 * @generated from message thru.services.v1.GetStateRootsResponse
 */
export type GetStateRootsResponse = Message<"thru.services.v1.GetStateRootsResponse"> & {
  /**
   * @generated from field: repeated thru.services.v1.StateRootEntry state_roots = 1;
   */
  stateRoots: StateRootEntry[];
};

/**
 * Describes the message thru.services.v1.GetStateRootsResponse.
 * Use `create(GetStateRootsResponseSchema)` to create a new message.
 */
export const GetStateRootsResponseSchema: GenMessage<GetStateRootsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 30);

/**
 * GetActiveStateHashesRequest retrieves active state hashes for a range of slots.
 *
 * @generated from message thru.services.v1.GetActiveStateHashesRequest
 */
export type GetActiveStateHashesRequest = Message<"thru.services.v1.GetActiveStateHashesRequest"> & {
  /**
   * The upper bound slot (inclusive). If not specified, defaults to the
   * durable cursor: the highest slot the node has durably committed, which
   * lags the finalized slot GetHeight reports by design. An end_slot above
   * the durable cursor is rejected with FAILED_PRECONDITION; if no slot is
   * durable yet the call returns UNAVAILABLE.
   *
   * @generated from field: optional uint64 end_slot = 1;
   */
  endSlot?: bigint | undefined;

  /**
   * The lower bound slot (inclusive). If not specified, defaults to max(0, end_slot - 127).
   *
   * @generated from field: optional uint64 start_slot = 2;
   */
  startSlot?: bigint | undefined;
};

/**
 * Describes the message thru.services.v1.GetActiveStateHashesRequest.
 * Use `create(GetActiveStateHashesRequestSchema)` to create a new message.
 */
export const GetActiveStateHashesRequestSchema: GenMessage<GetActiveStateHashesRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 31);

/**
 * ActiveStateHashEntry represents an active state hash for a specific slot.
 *
 * @generated from message thru.services.v1.ActiveStateHashEntry
 */
export type ActiveStateHashEntry = Message<"thru.services.v1.ActiveStateHashEntry"> & {
  /**
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * @generated from field: bytes active_state_hash = 2;
   */
  activeStateHash: Uint8Array;
};

/**
 * Describes the message thru.services.v1.ActiveStateHashEntry.
 * Use `create(ActiveStateHashEntrySchema)` to create a new message.
 */
export const ActiveStateHashEntrySchema: GenMessage<ActiveStateHashEntry> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 32);

/**
 * GetActiveStateHashesResponse contains active state hashes ending at the requested slot.
 *
 * @generated from message thru.services.v1.GetActiveStateHashesResponse
 */
export type GetActiveStateHashesResponse = Message<"thru.services.v1.GetActiveStateHashesResponse"> & {
  /**
   * @generated from field: repeated thru.services.v1.ActiveStateHashEntry active_state_hashes = 1;
   */
  activeStateHashes: ActiveStateHashEntry[];
};

/**
 * Describes the message thru.services.v1.GetActiveStateHashesResponse.
 * Use `create(GetActiveStateHashesResponseSchema)` to create a new message.
 */
export const GetActiveStateHashesResponseSchema: GenMessage<GetActiveStateHashesResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 33);

/**
 * GetSlotMetricsRequest retrieves metrics for a specific slot.
 *
 * @generated from message thru.services.v1.GetSlotMetricsRequest
 */
export type GetSlotMetricsRequest = Message<"thru.services.v1.GetSlotMetricsRequest"> & {
  /**
   * Block slot number to retrieve metrics for.
   *
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;
};

/**
 * Describes the message thru.services.v1.GetSlotMetricsRequest.
 * Use `create(GetSlotMetricsRequestSchema)` to create a new message.
 */
export const GetSlotMetricsRequestSchema: GenMessage<GetSlotMetricsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 34);

/**
 * GetSlotMetricsResponse contains slot-level metrics.
 *
 * @generated from message thru.services.v1.GetSlotMetricsResponse
 */
export type GetSlotMetricsResponse = Message<"thru.services.v1.GetSlotMetricsResponse"> & {
  /**
   * Block slot number.
   *
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * Global counter tracking total activated state across all accounts.
   *
   * @generated from field: uint64 global_activated_state_counter = 2;
   */
  globalActivatedStateCounter: bigint;

  /**
   * Global counter tracking total deactivated state across all accounts.
   *
   * @generated from field: uint64 global_deactivated_state_counter = 3;
   */
  globalDeactivatedStateCounter: bigint;

  /**
   * Fees credited to the absent-block-producer fee receiver this block
   * because the block producer account was not live (UNTO-1293). Field
   * number unchanged (4).
   *
   * @generated from field: uint64 absent_block_producer_fees = 4;
   */
  absentBlockProducerFees: bigint;

  /**
   * Block timestamp when available.
   *
   * @generated from field: optional google.protobuf.Timestamp block_timestamp = 5;
   */
  blockTimestamp?: Timestamp | undefined;

  /**
   * Fees credited to a live block-producer account this block. Disjoint from
   * absent_block_producer_fees by destination; total block fees =
   * absent_block_producer_fees + claimed_fees.
   *
   * @generated from field: uint64 claimed_fees = 6;
   */
  claimedFees: bigint;
};

/**
 * Describes the message thru.services.v1.GetSlotMetricsResponse.
 * Use `create(GetSlotMetricsResponseSchema)` to create a new message.
 */
export const GetSlotMetricsResponseSchema: GenMessage<GetSlotMetricsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 35);

/**
 * ListSlotMetricsRequest lists slot metrics for a range of slots.
 *
 * @generated from message thru.services.v1.ListSlotMetricsRequest
 */
export type ListSlotMetricsRequest = Message<"thru.services.v1.ListSlotMetricsRequest"> & {
  /**
   * Start slot for the range (inclusive).
   *
   * @generated from field: uint64 start_slot = 1;
   */
  startSlot: bigint;

  /**
   * End slot for the range (inclusive). Defaults to start_slot if not specified.
   *
   * @generated from field: optional uint64 end_slot = 2;
   */
  endSlot?: bigint | undefined;

  /**
   * Maximum number of results to return. Defaults to 100.
   *
   * @generated from field: optional uint32 limit = 3;
   */
  limit?: number | undefined;
};

/**
 * Describes the message thru.services.v1.ListSlotMetricsRequest.
 * Use `create(ListSlotMetricsRequestSchema)` to create a new message.
 */
export const ListSlotMetricsRequestSchema: GenMessage<ListSlotMetricsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 36);

/**
 * ListSlotMetricsResponse contains a list of slot metrics.
 *
 * @generated from message thru.services.v1.ListSlotMetricsResponse
 */
export type ListSlotMetricsResponse = Message<"thru.services.v1.ListSlotMetricsResponse"> & {
  /**
   * @generated from field: repeated thru.services.v1.GetSlotMetricsResponse metrics = 1;
   */
  metrics: GetSlotMetricsResponse[];
};

/**
 * Describes the message thru.services.v1.ListSlotMetricsResponse.
 * Use `create(ListSlotMetricsResponseSchema)` to create a new message.
 */
export const ListSlotMetricsResponseSchema: GenMessage<ListSlotMetricsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 37);

/**
 * GetNodePubkeyRequest requests the node's own public key.
 *
 * @generated from message thru.services.v1.GetNodePubkeyRequest
 */
export type GetNodePubkeyRequest = Message<"thru.services.v1.GetNodePubkeyRequest"> & {
};

/**
 * Describes the message thru.services.v1.GetNodePubkeyRequest.
 * Use `create(GetNodePubkeyRequestSchema)` to create a new message.
 */
export const GetNodePubkeyRequestSchema: GenMessage<GetNodePubkeyRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 38);

/**
 * GetNodePubkeyResponse returns the node's ED25519 public key.
 *
 * @generated from message thru.services.v1.GetNodePubkeyResponse
 */
export type GetNodePubkeyResponse = Message<"thru.services.v1.GetNodePubkeyResponse"> & {
  /**
   * @generated from field: thru.common.v1.Pubkey pubkey = 1;
   */
  pubkey?: Pubkey | undefined;
};

/**
 * Describes the message thru.services.v1.GetNodePubkeyResponse.
 * Use `create(GetNodePubkeyResponseSchema)` to create a new message.
 */
export const GetNodePubkeyResponseSchema: GenMessage<GetNodePubkeyResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 39);

/**
 * GetNodeRecordsRequest requests all known node records.
 *
 * @generated from message thru.services.v1.GetNodeRecordsRequest
 */
export type GetNodeRecordsRequest = Message<"thru.services.v1.GetNodeRecordsRequest"> & {
};

/**
 * Describes the message thru.services.v1.GetNodeRecordsRequest.
 * Use `create(GetNodeRecordsRequestSchema)` to create a new message.
 */
export const GetNodeRecordsRequestSchema: GenMessage<GetNodeRecordsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 40);

/**
 * GetNodeRecordsResponse returns all known node records from the gossip network.
 *
 * @generated from message thru.services.v1.GetNodeRecordsResponse
 */
export type GetNodeRecordsResponse = Message<"thru.services.v1.GetNodeRecordsResponse"> & {
  /**
   * @generated from field: repeated thru.core.v1.NodeRecord records = 1;
   */
  records: NodeRecord[];
};

/**
 * Describes the message thru.services.v1.GetNodeRecordsResponse.
 * Use `create(GetNodeRecordsResponseSchema)` to create a new message.
 */
export const GetNodeRecordsResponseSchema: GenMessage<GetNodeRecordsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 41);

/**
 * GetNodeStatusRequest requests the node's operational status.
 *
 * @generated from message thru.services.v1.GetNodeStatusRequest
 */
export type GetNodeStatusRequest = Message<"thru.services.v1.GetNodeStatusRequest"> & {
};

/**
 * Describes the message thru.services.v1.GetNodeStatusRequest.
 * Use `create(GetNodeStatusRequestSchema)` to create a new message.
 */
export const GetNodeStatusRequestSchema: GenMessage<GetNodeStatusRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 42);

/**
 * GetNodeStatusResponse returns the node's operational status including
 * consensus readiness, repair state, and current heights.
 *
 * @generated from message thru.services.v1.GetNodeStatusResponse
 */
export type GetNodeStatusResponse = Message<"thru.services.v1.GetNodeStatusResponse"> & {
  /**
   * High-level readiness flag. True when consensus is active and the node
   * is ready to accept and process transactions.
   *
   * @generated from field: bool ready = 1;
   */
  ready: boolean;

  /**
   * Consensus subsystem state.
   *
   * @generated from field: thru.services.v1.NodeConsensusStatus consensus = 2;
   */
  consensus?: NodeConsensusStatus | undefined;

  /**
   * Repair subsystem state.
   *
   * @generated from field: thru.services.v1.NodeRepairStatus repair = 3;
   */
  repair?: NodeRepairStatus | undefined;

  /**
   * Latest finalized slot.
   *
   * @generated from field: uint64 finalized_slot = 4;
   */
  finalizedSlot: bigint;

  /**
   * Latest locally executed slot.
   *
   * @generated from field: uint64 locally_executed_slot = 5;
   */
  locallyExecutedSlot: bigint;
};

/**
 * Describes the message thru.services.v1.GetNodeStatusResponse.
 * Use `create(GetNodeStatusResponseSchema)` to create a new message.
 */
export const GetNodeStatusResponseSchema: GenMessage<GetNodeStatusResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 43);

/**
 * NodeConsensusStatus describes the consensus driver state.
 *
 * @generated from message thru.services.v1.NodeConsensusStatus
 */
export type NodeConsensusStatus = Message<"thru.services.v1.NodeConsensusStatus"> & {
  /**
   * Whether post-repair consensus is active and voting.
   *
   * @generated from field: bool active = 1;
   */
  active: boolean;

  /**
   * How consensus was entered: regular startup or catastrophic recovery.
   *
   * @generated from field: thru.services.v1.NodeMode mode = 2;
   */
  mode: NodeMode;

  /**
   * Current consensus frontier slot (first slot without EXECUTION_FINISHED).
   *
   * @generated from field: uint64 frontier = 3;
   */
  frontier: bigint;
};

/**
 * Describes the message thru.services.v1.NodeConsensusStatus.
 * Use `create(NodeConsensusStatusSchema)` to create a new message.
 */
export const NodeConsensusStatusSchema: GenMessage<NodeConsensusStatus> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 44);

/**
 * NodeRepairStatus describes the repair subsystem state.
 *
 * @generated from message thru.services.v1.NodeRepairStatus
 */
export type NodeRepairStatus = Message<"thru.services.v1.NodeRepairStatus"> & {
  /**
   * Whether catastrophic repair gating is active. When true, the node is
   * suppressing consensus output and rejecting transactions.
   * Note: during normal gap repair (non-catastrophic), this is false but
   * consensus.active is also false, so ready is correctly false.
   *
   * @generated from field: bool active = 1;
   */
  active: boolean;
};

/**
 * Describes the message thru.services.v1.NodeRepairStatus.
 * Use `create(NodeRepairStatusSchema)` to create a new message.
 */
export const NodeRepairStatusSchema: GenMessage<NodeRepairStatus> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 45);

/**
 * BatchGetRawAccountsRequest fetches raw bytes for many accounts in one call.
 *
 * Batching exists because the per-account path costs up to three ClickHouse
 * round-trips (current meta, historical meta, historical pages), so N accounts
 * fetched one at a time is 3N sequential queries. The batch answers the whole
 * set in a fixed number of queries regardless of N.
 *
 * @generated from message thru.services.v1.BatchGetRawAccountsRequest
 */
export type BatchGetRawAccountsRequest = Message<"thru.services.v1.BatchGetRawAccountsRequest"> & {
  /**
   * The accounts to fetch. At most 1000 (BATCH_GET_MAX_ITEMS); a larger batch
   * is rejected with INVALID_ARGUMENT rather than silently truncated, because
   * the address list is rendered into the SQL and would otherwise run into
   * ClickHouse's max_query_size.
   *
   * @generated from field: repeated thru.services.v1.BatchGetRawAccountsItem items = 1;
   */
  items: BatchGetRawAccountsItem[];

  /**
   * Version applied to every item that does not carry its own. Set this alone
   * to read the whole batch at one version -- the common case -- instead of
   * repeating the same context on each item.
   *
   * @generated from field: optional thru.common.v1.VersionContext version_context = 2;
   */
  versionContext?: VersionContext | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 3;
   */
  minConsensus?: ConsensusStatus | undefined;

  /**
   * @generated from field: optional thru.core.v1.AccountView view = 4;
   */
  view?: AccountView | undefined;
};

/**
 * Describes the message thru.services.v1.BatchGetRawAccountsRequest.
 * Use `create(BatchGetRawAccountsRequestSchema)` to create a new message.
 */
export const BatchGetRawAccountsRequestSchema: GenMessage<BatchGetRawAccountsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 46);

/**
 * BatchGetRawAccountsItem is one account in a batch, optionally pinned to its
 * own version.
 *
 * @generated from message thru.services.v1.BatchGetRawAccountsItem
 */
export type BatchGetRawAccountsItem = Message<"thru.services.v1.BatchGetRawAccountsItem"> & {
  /**
   * @generated from field: thru.common.v1.Pubkey address = 1;
   */
  address?: Pubkey | undefined;

  /**
   * Overrides the request-level version_context for this account only. Leave
   * unset to inherit it. Set it when the batch reads accounts at DIFFERENT
   * versions -- e.g. verifying each account at the slot its own transaction
   * executed in.
   *
   * @generated from field: optional thru.common.v1.VersionContext version_context = 2;
   */
  versionContext?: VersionContext | undefined;
};

/**
 * Describes the message thru.services.v1.BatchGetRawAccountsItem.
 * Use `create(BatchGetRawAccountsItemSchema)` to create a new message.
 */
export const BatchGetRawAccountsItemSchema: GenMessage<BatchGetRawAccountsItem> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 47);

/**
 * BatchGetRawAccountsResponse returns the accounts that were found.
 *
 * PARTIAL BY DESIGN: an address that does not exist is simply ABSENT from the
 * map rather than failing the call, so one missing account cannot destroy a
 * batch of 1000. Callers must look up their addresses rather than assume the
 * map is complete.
 *
 * @generated from message thru.services.v1.BatchGetRawAccountsResponse
 */
export type BatchGetRawAccountsResponse = Message<"thru.services.v1.BatchGetRawAccountsResponse"> & {
  /**
   * Keyed by the encoded account address, as returned elsewhere in this API.
   *
   * @generated from field: map<string, thru.core.v1.RawAccount> accounts = 1;
   */
  accounts: { [key: string]: RawAccount };
};

/**
 * Describes the message thru.services.v1.BatchGetRawAccountsResponse.
 * Use `create(BatchGetRawAccountsResponseSchema)` to create a new message.
 */
export const BatchGetRawAccountsResponseSchema: GenMessage<BatchGetRawAccountsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 48);

/**
 * BatchGetTransactionsRequest fetches many decoded transactions in one call.
 *
 * @generated from message thru.services.v1.BatchGetTransactionsRequest
 */
export type BatchGetTransactionsRequest = Message<"thru.services.v1.BatchGetTransactionsRequest"> & {
  /**
   * At most 1000 (BATCH_GET_MAX_ITEMS); see BatchGetRawAccountsRequest.items.
   *
   * @generated from field: repeated thru.common.v1.Signature signatures = 1;
   */
  signatures: Signature[];

  /**
   * @generated from field: optional thru.common.v1.VersionContext version_context = 2;
   */
  versionContext?: VersionContext | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus min_consensus = 3;
   */
  minConsensus?: ConsensusStatus | undefined;

  /**
   * @generated from field: optional thru.core.v1.TransactionView view = 4;
   */
  view?: TransactionView | undefined;
};

/**
 * Describes the message thru.services.v1.BatchGetTransactionsRequest.
 * Use `create(BatchGetTransactionsRequestSchema)` to create a new message.
 */
export const BatchGetTransactionsRequestSchema: GenMessage<BatchGetTransactionsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 49);

/**
 * BatchGetTransactionsResponse returns the transactions that were found.
 *
 * PARTIAL BY DESIGN, exactly as BatchGetRawAccountsResponse: an unknown
 * signature is absent from the map, not an error.
 *
 * @generated from message thru.services.v1.BatchGetTransactionsResponse
 */
export type BatchGetTransactionsResponse = Message<"thru.services.v1.BatchGetTransactionsResponse"> & {
  /**
   * Keyed by the encoded transaction signature.
   *
   * @generated from field: map<string, thru.core.v1.Transaction> transactions = 1;
   */
  transactions: { [key: string]: Transaction };
};

/**
 * Describes the message thru.services.v1.BatchGetTransactionsResponse.
 * Use `create(BatchGetTransactionsResponseSchema)` to create a new message.
 */
export const BatchGetTransactionsResponseSchema: GenMessage<BatchGetTransactionsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 50);

/**
 * BatchGenerateStateProofsRequest generates many state proofs in one call.
 *
 * A single proof descends the state trie root-to-leaf, one node fetch per
 * level, and that descent cannot be parallelised -- each node is what reveals
 * the next hash.  What CAN be shared is the descent across proofs: every
 * request in the batch needs its depth-d node at the same moment, so N proofs
 * over a depth-D trie cost D round-trips rather than N*D.
 *
 * @generated from message thru.services.v1.BatchGenerateStateProofsRequest
 */
export type BatchGenerateStateProofsRequest = Message<"thru.services.v1.BatchGenerateStateProofsRequest"> & {
  /**
   * At most 1000; a larger batch is rejected rather than truncated.
   *
   * Every request's own target_slot must be UNSET: the slot is chosen once for
   * the batch, below. A request that sets it is rejected rather than ignored.
   *
   * @generated from field: repeated thru.core.v1.StateProofRequest requests = 1;
   */
  requests: StateProofRequest[];

  /**
   * The slot whose state root every proof in this batch is built against.
   * Unset (or 0) selects the latest usable root, as the per-request RPC does.
   *
   * BATCH-LEVEL, NOT PER-REQUEST, deliberately. A proof is only usable by a
   * block whose execution slot falls inside the runtime's ACCEPTS window, so
   * every proof a caller assembles for one block already shares one slot;
   * mixing slots in a batch has no use and is expensive to serve. Each distinct
   * slot costs its own root resolution and its own full trie descent, so a
   * 1000-request batch of distinct slots performs ~1000 descents instead of one
   * shared walk -- the same work as 1000 separate calls, bought with a single
   * round-trip. Hoisting the slot here makes that shape unrepresentable rather
   * than merely rejected.
   *
   * @generated from field: optional uint64 target_slot = 2;
   */
  targetSlot?: bigint | undefined;
};

/**
 * Describes the message thru.services.v1.BatchGenerateStateProofsRequest.
 * Use `create(BatchGenerateStateProofsRequestSchema)` to create a new message.
 */
export const BatchGenerateStateProofsRequestSchema: GenMessage<BatchGenerateStateProofsRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 51);

/**
 * BatchGenerateStateProofsResponse returns one result per request, IN THE ORDER
 * REQUESTED.
 *
 * Results are positional rather than keyed because the same account may
 * legitimately appear more than once in a batch (at different proof types), so
 * an address alone does not identify a request.
 *
 * @generated from message thru.services.v1.BatchGenerateStateProofsResponse
 */
export type BatchGenerateStateProofsResponse = Message<"thru.services.v1.BatchGenerateStateProofsResponse"> & {
  /**
   * @generated from field: repeated thru.services.v1.StateProofResult results = 1;
   */
  results: StateProofResult[];
};

/**
 * Describes the message thru.services.v1.BatchGenerateStateProofsResponse.
 * Use `create(BatchGenerateStateProofsResponseSchema)` to create a new message.
 */
export const BatchGenerateStateProofsResponseSchema: GenMessage<BatchGenerateStateProofsResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 52);

/**
 * StateProofResult is one request's outcome.
 *
 * PARTIAL BY DESIGN: a key that cannot be proved -- absent when membership was
 * asked, present when non-membership was -- is an ordinary answer ABOUT THAT
 * KEY and must not fail the other 999.  Exactly one of proof/error is set.
 *
 * @generated from message thru.services.v1.StateProofResult
 */
export type StateProofResult = Message<"thru.services.v1.StateProofResult"> & {
  /**
   * @generated from field: optional thru.core.v1.StateProof proof = 1;
   */
  proof?: StateProof | undefined;

  /**
   * google.rpc.Code for this request, 0 when proof is set.
   *
   * @generated from field: optional int32 error_code = 2;
   */
  errorCode?: number | undefined;

  /**
   * @generated from field: optional string error_message = 3;
   */
  errorMessage?: string | undefined;
};

/**
 * Describes the message thru.services.v1.StateProofResult.
 * Use `create(StateProofResultSchema)` to create a new message.
 */
export const StateProofResultSchema: GenMessage<StateProofResult> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 53);

/**
 * GetCompressionConfigRequest requests the current durable compression inputs.
 *
 * @generated from message thru.services.v1.GetCompressionConfigRequest
 */
export type GetCompressionConfigRequest = Message<"thru.services.v1.GetCompressionConfigRequest"> & {
};

/**
 * Describes the message thru.services.v1.GetCompressionConfigRequest.
 * Use `create(GetCompressionConfigRequestSchema)` to create a new message.
 */
export const GetCompressionConfigRequestSchema: GenMessage<GetCompressionConfigRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 54);

/**
 * CompressionConfig contains inputs from one durable finalized slot.
 *
 * @generated from message thru.services.v1.CompressionConfig
 */
export type CompressionConfig = Message<"thru.services.v1.CompressionConfig"> & {
  /**
   * Finalized slot shared by the account metadata, activity, and policy inputs.
   *
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * Settled net-growth counter in state units, not wall-clock time.
   *
   * @generated from field: uint64 state_clock = 2;
   */
  stateClock: bigint;

  /**
   * Active state-unit load used by the compression eligibility policy.
   *
   * @generated from field: uint64 active_state_units = 3;
   */
  activeStateUnits: bigint;

  /**
   * Maximum state units a block may consume.
   *
   * @generated from field: uint64 max_state_units_per_block = 4;
   */
  maxStateUnitsPerBlock: bigint;

  /**
   * Maximum active state units configured for the chain.
   *
   * @generated from field: uint64 max_active_state_units = 5;
   */
  maxActiveStateUnits: bigint;

  /**
   * Active-load baseline, in state units, below which compression is disabled.
   *
   * @generated from field: uint64 compress_baseline_units = 6;
   */
  compressBaselineUnits: bigint;

  /**
   * Additional load, in state units, for each halving of the inactivity window.
   *
   * @generated from field: uint64 compress_halving_step_units = 7;
   */
  compressHalvingStepUnits: bigint;
};

/**
 * Describes the message thru.services.v1.CompressionConfig.
 * Use `create(CompressionConfigSchema)` to create a new message.
 */
export const CompressionConfigSchema: GenMessage<CompressionConfig> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 55);

/**
 * CanCompressRequest identifies the active account to evaluate.
 *
 * @generated from message thru.services.v1.CanCompressRequest
 */
export type CanCompressRequest = Message<"thru.services.v1.CanCompressRequest"> & {
  /**
   * Address of the account whose activity and metadata are checked.
   *
   * @generated from field: thru.common.v1.Pubkey address = 1;
   */
  address?: Pubkey | undefined;
};

/**
 * Describes the message thru.services.v1.CanCompressRequest.
 * Use `create(CanCompressRequestSchema)` to create a new message.
 */
export const CanCompressRequestSchema: GenMessage<CanCompressRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 56);

/**
 * CanCompressResponse returns eligibility and its consistent durable inputs.
 *
 * @generated from message thru.services.v1.CanCompressResponse
 */
export type CanCompressResponse = Message<"thru.services.v1.CanCompressResponse"> & {
  /**
   * Non-owner inactivity-policy eligibility, also respecting UNCOMPRESSABLE.
   * This is a prediction at config.slot, not transaction admission: proofs,
   * startup warmup, cooldown, write locks and call-stack checks still apply.
   *
   * @generated from field: bool can_compress = 1;
   */
  canCompress: boolean;

  /**
   * Account's last activity stamp in state-clock units; zero if absent.
   *
   * @generated from field: uint64 last_used = 2;
   */
  lastUsed: bigint;

  /**
   * Policy inputs from the same finalized slot as the account's activity.
   *
   * @generated from field: thru.services.v1.CompressionConfig config = 3;
   */
  config?: CompressionConfig | undefined;
};

/**
 * Describes the message thru.services.v1.CanCompressResponse.
 * Use `create(CanCompressResponseSchema)` to create a new message.
 */
export const CanCompressResponseSchema: GenMessage<CanCompressResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_query_service, 57);

/**
 * NodeMode represents the consensus/repair operating mode.
 *
 * @generated from enum thru.services.v1.NodeMode
 */
export enum NodeMode {
  /**
   * @generated from enum value: NODE_MODE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NODE_MODE_REGULAR = 1;
   */
  REGULAR = 1,

  /**
   * @generated from enum value: NODE_MODE_CATASTROPHIC = 2;
   */
  CATASTROPHIC = 2,
}

/**
 * Describes the enum thru.services.v1.NodeMode.
 */
export const NodeModeSchema: GenEnum<NodeMode> = /*@__PURE__*/
  enumDesc(file_thru_services_v1_query_service, 0);

/**
 * QueryService defines unary RPCs for accessing blockchain data.
 *
 * @generated from service thru.services.v1.QueryService
 */
export const QueryService: GenService<{
  /**
   * Returns typed chain parameters and the state clock in one durable view.
   *
   * @generated from rpc thru.services.v1.QueryService.GetCompressionConfig
   */
  getCompressionConfig: {
    methodKind: "unary";
    input: typeof GetCompressionConfigRequestSchema;
    output: typeof CompressionConfigSchema;
  },
  /**
   * Reads account metadata, activity and config from the same durable snapshot.
   *
   * @generated from rpc thru.services.v1.QueryService.CanCompress
   */
  canCompress: {
    methodKind: "unary";
    input: typeof CanCompressRequestSchema;
    output: typeof CanCompressResponseSchema;
  },
  /**
   * Get block heights
   *
   * @generated from rpc thru.services.v1.QueryService.GetHeight
   */
  getHeight: {
    methodKind: "unary";
    input: typeof GetHeightRequestSchema;
    output: typeof GetHeightResponseSchema;
  },
  /**
   * Get chain-level information including chain ID.
   *
   * @generated from rpc thru.services.v1.QueryService.GetChainInfo
   */
  getChainInfo: {
    methodKind: "unary";
    input: typeof GetChainInfoRequestSchema;
    output: typeof GetChainInfoResponseSchema;
  },
  /**
   * Get account information.
   *
   * @generated from rpc thru.services.v1.QueryService.GetAccount
   */
  getAccount: {
    methodKind: "unary";
    input: typeof GetAccountRequestSchema;
    output: typeof AccountSchema;
  },
  /**
   * Get account raw bytes.
   *
   * @generated from rpc thru.services.v1.QueryService.GetRawAccount
   */
  getRawAccount: {
    methodKind: "unary";
    input: typeof GetRawAccountRequestSchema;
    output: typeof RawAccountSchema;
  },
  /**
   * Get raw bytes for many accounts in one call. Partial: addresses that do
   * not exist are absent from the response map.
   *
   * @generated from rpc thru.services.v1.QueryService.BatchGetRawAccounts
   */
  batchGetRawAccounts: {
    methodKind: "unary";
    input: typeof BatchGetRawAccountsRequestSchema;
    output: typeof BatchGetRawAccountsResponseSchema;
  },
  /**
   * Get many transactions in one call. Partial: unknown signatures are absent
   * from the response map.
   *
   * @generated from rpc thru.services.v1.QueryService.BatchGetTransactions
   */
  batchGetTransactions: {
    methodKind: "unary";
    input: typeof BatchGetTransactionsRequestSchema;
    output: typeof BatchGetTransactionsResponseSchema;
  },
  /**
   * Get transaction by signature.
   *
   * @generated from rpc thru.services.v1.QueryService.GetTransaction
   */
  getTransaction: {
    methodKind: "unary";
    input: typeof GetTransactionRequestSchema;
    output: typeof TransactionSchema;
  },
  /**
   * Get raw transaction by signature.
   *
   * @generated from rpc thru.services.v1.QueryService.GetRawTransaction
   */
  getRawTransaction: {
    methodKind: "unary";
    input: typeof GetRawTransactionRequestSchema;
    output: typeof RawTransactionSchema;
  },
  /**
   * Get block by slot or hash.
   *
   * @generated from rpc thru.services.v1.QueryService.GetBlock
   */
  getBlock: {
    methodKind: "unary";
    input: typeof GetBlockRequestSchema;
    output: typeof BlockSchema;
  },
  /**
   * Get raw block bytes.
   *
   * @generated from rpc thru.services.v1.QueryService.GetRawBlock
   */
  getRawBlock: {
    methodKind: "unary";
    input: typeof GetRawBlockRequestSchema;
    output: typeof RawBlockSchema;
  },
  /**
   * List accounts using CEL-based filtering.
   *
   * @generated from rpc thru.services.v1.QueryService.ListAccounts
   */
  listAccounts: {
    methodKind: "unary";
    input: typeof ListAccountsRequestSchema;
    output: typeof ListAccountsResponseSchema;
  },
  /**
   * List blocks using pagination and filtering. By default returns blocks ordered from latest slot to the first one.
   *
   * @generated from rpc thru.services.v1.QueryService.ListBlocks
   */
  listBlocks: {
    methodKind: "unary";
    input: typeof ListBlocksRequestSchema;
    output: typeof ListBlocksResponseSchema;
  },
  /**
   * List executed transaction signatures involving an account.
   *
   * @generated from rpc thru.services.v1.QueryService.ListTransactionsForAccount
   */
  listTransactionsForAccount: {
    methodKind: "unary";
    input: typeof ListTransactionsForAccountRequestSchema;
    output: typeof ListTransactionsForAccountResponseSchema;
  },
  /**
   * Get a specific event by ID.
   *
   * @generated from rpc thru.services.v1.QueryService.GetEvent
   */
  getEvent: {
    methodKind: "unary";
    input: typeof GetEventRequestSchema;
    output: typeof EventSchema;
  },
  /**
   * List events with CEL filtering and pagination. Returns events ordered from most recent to older.
   *
   * @generated from rpc thru.services.v1.QueryService.ListEvents
   */
  listEvents: {
    methodKind: "unary";
    input: typeof ListEventsRequestSchema;
    output: typeof ListEventsResponseSchema;
  },
  /**
   * List executed transactions with CEL filtering and pagination. Returns transactions ordered from most recent to older.
   *
   * @generated from rpc thru.services.v1.QueryService.ListTransactions
   */
  listTransactions: {
    methodKind: "unary";
    input: typeof ListTransactionsRequestSchema;
    output: typeof ListTransactionsResponseSchema;
  },
  /**
   * Get derived transaction status metadata.
   *
   * @generated from rpc thru.services.v1.QueryService.GetTransactionStatus
   */
  getTransactionStatus: {
    methodKind: "unary";
    input: typeof GetTransactionStatusRequestSchema;
    output: typeof TransactionStatusSchema;
  },
  /**
   * Generate an account state proof snapshot.
   * Generate many state proofs in one call, sharing the trie descent across
   * them. Partial: a request that cannot be proved carries its own error.
   *
   * @generated from rpc thru.services.v1.QueryService.BatchGenerateStateProofs
   */
  batchGenerateStateProofs: {
    methodKind: "unary";
    input: typeof BatchGenerateStateProofsRequestSchema;
    output: typeof BatchGenerateStateProofsResponseSchema;
  },
  /**
   * @generated from rpc thru.services.v1.QueryService.GenerateStateProof
   */
  generateStateProof: {
    methodKind: "unary";
    input: typeof GenerateStateProofRequestSchema;
    output: typeof GenerateStateProofResponseSchema;
  },
  /**
   * Get component version strings.
   *
   * @generated from rpc thru.services.v1.QueryService.GetVersion
   */
  getVersion: {
    methodKind: "unary";
    input: typeof GetVersionRequestSchema;
    output: typeof GetVersionResponseSchema;
  },
  /**
   * Get state roots for a range of slots.
   * Used for transaction replay to verify state proofs against historical roots.
   *
   * @generated from rpc thru.services.v1.QueryService.GetStateRoots
   */
  getStateRoots: {
    methodKind: "unary";
    input: typeof GetStateRootsRequestSchema;
    output: typeof GetStateRootsResponseSchema;
  },
  /**
   * Get active state hashes for a range of slots.
   *
   * @generated from rpc thru.services.v1.QueryService.GetActiveStateHashes
   */
  getActiveStateHashes: {
    methodKind: "unary";
    input: typeof GetActiveStateHashesRequestSchema;
    output: typeof GetActiveStateHashesResponseSchema;
  },
  /**
   * Get slot-level metrics including state counters and distributed fees
   * (absent-block-producer + claimed).
   *
   * @generated from rpc thru.services.v1.QueryService.GetSlotMetrics
   */
  getSlotMetrics: {
    methodKind: "unary";
    input: typeof GetSlotMetricsRequestSchema;
    output: typeof GetSlotMetricsResponseSchema;
  },
  /**
   * List slot metrics for a range of slots.
   *
   * @generated from rpc thru.services.v1.QueryService.ListSlotMetrics
   */
  listSlotMetrics: {
    methodKind: "unary";
    input: typeof ListSlotMetricsRequestSchema;
    output: typeof ListSlotMetricsResponseSchema;
  },
  /**
   * Get the node's own ED25519 public key.
   *
   * @generated from rpc thru.services.v1.QueryService.GetNodePubkey
   */
  getNodePubkey: {
    methodKind: "unary";
    input: typeof GetNodePubkeyRequestSchema;
    output: typeof GetNodePubkeyResponseSchema;
  },
  /**
   * Get all known node records from the gossip network.
   *
   * @generated from rpc thru.services.v1.QueryService.GetNodeRecords
   */
  getNodeRecords: {
    methodKind: "unary";
    input: typeof GetNodeRecordsRequestSchema;
    output: typeof GetNodeRecordsResponseSchema;
  },
  /**
   * Get the node's operational status including consensus readiness.
   *
   * @generated from rpc thru.services.v1.QueryService.GetNodeStatus
   */
  getNodeStatus: {
    methodKind: "unary";
    input: typeof GetNodeStatusRequestSchema;
    output: typeof GetNodeStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_thru_services_v1_query_service, 0);

